<template lang="pug">
  SspLayout(area="tnt")
    .row
      .col-md-12
        .panel.panel-default
          .panel-body
            form.form-horizontal(role="form" @submit.prevent="registerEvent()")
              .form-group
                label.col-md-1.control-label(for="location")  Location
                .col-md-9
                  LocationPicker(v-model="event.location")
              .form-group
                label.col-md-1.control-label(for="code") Code
                .col-md-9
                  input.form-control.code-input(v-model="event.code" type="text" placeholder="Code")
                .col-md-2
                  SspActionButton(type="submit" :spinning="registering" :disabled="!isValid" text="Register sale")

    GenericTable
      tr(slot="thead")
        th Code
        th.hidden-xs Time
        th Location
        th Status
      tr(v-for="i in list")
        td {{i.epcs[0]}}
        td.hidden-xs {{i.eventTime | date}}
        td {{i.locationName}}
        td {{i.message}}

</template>
<script>
import GenericTable from '@/components/common/GenericTable'
import LocationPicker from '@/components/ssp/LocationPicker'
import TrackNTrace from '@/service/apis/TrackNTrace'
import { dateFilter } from '@/filters/filters'
import Util from '@/service/Util'

export default {
  data: () => ({
    registering: false,
    event: {
      code: null,
      location: null
    },
    locationName: null,
    message: null,
    list: []
  }),
  methods: {
    registerEvent() {
      this.registering = true
      if (!this.event.location || !this.event.code) {
        return
      }

      const event = {
        allowImplicitSplit: true,
        epcs: Util.sanitizeCodes(this.event.code),
        message: '',
        location: `urn:kezzler:loc:${this.event.location.id}`,
        locationName: this.event.location.name,
        disposition: 'urn:epcglobal:cbv:disp:retail_sold',
        bizStep: 'urn:epcglobal:cbv:bizstep:retail_selling'
      }
      this.list.push(event)

      return TrackNTrace.registerTrackingEvent(event)
        .then(() => {
          event.message = 'OK'
        })
        .catch((e) => {
          this.$emit('error', e)
        })
        .then(() => {
          this.registering = false
        })
    }
  },
  computed: {
    isValid() {
      return this.event.code && this.event.location
    }
  },
  components: {
    GenericTable,
    LocationPicker
  },
  filters: {
    date: dateFilter
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/trackntrace/Pos.vue